<script lang="ts">
  import Value from './partials/Value.svelte';
  import type { DataList } from '$provider/models/datalist/DataList';
  import ListAlert from '$shared/atoms/_ListAlert/ListAlert.svelte';

  interface Props {
    list?: DataList[];
    onevent?: (payload: any) => void;
  }

  let { list = [], onevent }: Props = $props();
</script>

{#each list as item, index}
  {@const key = item.key}
  <div class="list-i" class:noPad={item.isNoLableKey} class:odd={(index + 1) % 2 !== 0}>
    {#if !item.isNoLableKey}
      <div data-cy={`${key}-k`} class="key">
        {item.parsedKey}
      </div>
    {/if}
    <Value {item} {onevent} />
  </div>
  {#if item.alert?.key}
    <ListAlert alert={item.alert} {onevent} />
  {/if}
{:else}
  <div class="empty">No Data Found</div>
{/each}

<style>
  .list-i {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    line-height: 20px;
    color: var(--grey-dark);
  }
  .list-i.odd {
    background-color: var(--grey-bg) !important;
  }
  .list-i .key {
    width: 150px;
    flex-shrink: 0;
    margin-right: 16px;
    overflow: hidden;
    color: var(--black);
    font-weight: 500;
  }

  .list-i.noPad {
    padding: 0;
    background-color: #fff;
  }

  .empty {
    background-color: var(--grey-bg);
    line-height: 30px;
    padding: 0 8px;
    color: var(--grey-medium);
    font-style: italic;
  }
</style>
